import React from 'react';

const StateContext = React.createContext({});

export default StateContext;
